var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ql-snow"},[_c('div',{staticClass:"ql-editor"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }